import 'url-polyfill';
import Cookies from 'modules/Cookies';

const hlocale = window.hlocale || 'ja';
const langDic = window.langDic || [];

// =====================================
// EVENT LISTENERS
$(document).on('click', '.localeItem', e => {
  const setThis = $(e.currentTarget).data('hlocale');

  const url = new URL(window.location.href);
  url.searchParams.set('hl', setThis);
  window.location.href = url.href;
});

// =====================================
// FUNCTIONS
const initHLocale = () => {
  Cookies.set('hlocale', hlocale, { expires: 10000 });
  const url = new URL(window.location.href);
  url.searchParams.set('hl', hlocale);
  window.history.replaceState({}, '', url.href);
};

const resolveLang = (text, data) => {
  if (langDic[text]) {
    text = langDic[text];
  } else if (hlocale !== 'ja') {
    console.log(`text not found - ${text}`);
  }

  if (data) {
    _.forEach(data, (value, key) => {
      text = text.replace(new RegExp(`{{${key}}}`, 'g'), value);
    });
  }

  return text;
};

// set locale in cookie and url param
// url param is needed for SNS sharing link
initHLocale();

window.resolveLang = resolveLang;
